/** Product barcode label roll: 50mm × 25mm, 3mm gap between labels. */

export const PRODUCT_LABEL_WIDTH_MM = 50;

export const PRODUCT_LABEL_HEIGHT_MM = 25;

export const PRODUCT_LABEL_GAP_MM = 3;

export const PRODUCT_LABEL_PITCH_MM = PRODUCT_LABEL_HEIGHT_MM + PRODUCT_LABEL_GAP_MM;



/** 203 DPI — 8 dots/mm on TSC/POSIFLOW-class printers. */

export const PRODUCT_LABEL_DPI = 203;

export const PRODUCT_LABEL_DOTS_PER_MM = 8;



export const PRODUCT_LABEL_WIDTH_DOTS = Math.round(PRODUCT_LABEL_WIDTH_MM * PRODUCT_LABEL_DOTS_PER_MM);

export const PRODUCT_LABEL_HEIGHT_DOTS = Math.round(PRODUCT_LABEL_HEIGHT_MM * PRODUCT_LABEL_DOTS_PER_MM);

export const PRODUCT_LABEL_GAP_DOTS = Math.round(PRODUCT_LABEL_GAP_MM * PRODUCT_LABEL_DOTS_PER_MM);

export const PRODUCT_LABEL_PITCH_DOTS = PRODUCT_LABEL_HEIGHT_DOTS + PRODUCT_LABEL_GAP_DOTS;



/** Left/right inset from label edge (mm / dots). */
export const PRODUCT_LABEL_MARGIN_LEFT_MM = 2;
export const PRODUCT_LABEL_MARGIN_RIGHT_MM = 0.5;
export const PRODUCT_LABEL_MARGIN_LEFT_DOTS = Math.round(PRODUCT_LABEL_MARGIN_LEFT_MM * PRODUCT_LABEL_DOTS_PER_MM);
export const PRODUCT_LABEL_MARGIN_RIGHT_DOTS = Math.round(PRODUCT_LABEL_MARGIN_RIGHT_MM * PRODUCT_LABEL_DOTS_PER_MM);

/** Usable text width on a 50mm label (~1.4mm per char at font A). */
export const PRODUCT_LABEL_CHARS_PER_LINE = Math.floor(
  (PRODUCT_LABEL_WIDTH_MM - PRODUCT_LABEL_MARGIN_LEFT_MM - PRODUCT_LABEL_MARGIN_RIGHT_MM) / 1.4
);
export const PRODUCT_LABEL_COMPANY_MAX_CHARS = PRODUCT_LABEL_CHARS_PER_LINE;
export const PRODUCT_LABEL_NAME_MAX_CHARS = Math.floor(PRODUCT_LABEL_CHARS_PER_LINE * 0.75);
export const PRODUCT_LABEL_PRICE_MAX_CHARS = PRODUCT_LABEL_CHARS_PER_LINE + 4;

export const PRODUCT_LABEL_LINE_SPACING = 20;

export const PRODUCT_LABEL_BARCODE_HEIGHT_MM = 11;
export const PRODUCT_LABEL_BARCODE_HEIGHT_DOTS = 34;

export const PRODUCT_LABEL_BARCODE_MODULE_WIDTH = 2;



/**

 * Fixed Y slots (dots from top of label). Empty optional rows stay blank — same layout every time.

 */

export const PRODUCT_LABEL_ROW_Y = {

  company: 2,

  name: 22,

  price: 42,

  barcode: 60,

  barcodeText: 96,

} as const;



/** Wait between labels so the printer finishes gap feed before the next job (Bluetooth buffer). */

export const PRODUCT_LABEL_PRINT_DELAY_MS = 450;



/** GS P motion unit (0.01 mm) for ESC/POS page mode. */

export const PRODUCT_LABEL_MOTION_UNIT = Math.round(2540 / PRODUCT_LABEL_DPI);

export type LabelTemplate = 'classic' | 'retail';

export function normalizeLabelTemplate(value: unknown): LabelTemplate {
  return String(value || '').trim() === 'retail' ? 'retail' : 'classic';
}

/** Single-line price: "Rs. {sale}  MRP Rs. {mrp}" (omits missing values). */
export function formatLabelPriceLine(price?: number, mrp?: number): string {
  const parts: string[] = [];
  const salePrice = price && price > 0 ? price : 0;
  const mrpPrice = mrp && mrp > 0 ? mrp : 0;

  if (salePrice > 0) {
    parts.push(`Rs. ${salePrice.toFixed(2)}`);
  }
  if (mrpPrice > 0) {
    parts.push(`MRP Rs. ${mrpPrice.toFixed(2)}`);
  }

  return parts.join('  ');
}

/** Clip label text to fit width — no ellipsis (printer has spare room on the right). */
export function clipLabelText(text: string | null | undefined, max: number): string {
  const value = (text || '').trim();
  if (!value || max <= 0) {
    return '';
  }
  return value.length <= max ? value : value.slice(0, max);
}

